<template>
  <div class="loading" :style="{ height: `${height}px` }">
    <content-loader width="800" height="720" v-if="loaderType === 'appList'">
      <rect x="0" y="0" rx="0" ry="0" width="800" height="160" />
      <rect x="0" y="180" rx="0" ry="0" width="800" height="160" />
      <rect x="0" y="360" rx="0" ry="0" width="800" height="160" />
      <rect x="0" y="540" rx="0" ry="0" width="800" height="160" />
      <rect x="0" y="720" rx="0" ry="0" width="800" height="160" />
    </content-loader>



    <content-loader
      v-else
      :width="width"
      :height="height"
      :speed="speed"
      :backgroundColor="backgroundColor"
      :foregroundColor="foregroundColor"
    >
      <rect x="0" y="0" rx="4" ry="4" width="588" height="120" />
      <rect x="612" y="0" rx="4" ry="4" width="588" height="120" />

      <rect x="0" y="144" rx="4" ry="4" width="588" height="120" />
      <rect x="612" y="144" rx="4" ry="4" width="588" height="120" />

      <rect x="0" y="288" rx="4" ry="4" width="588" height="120" />
      <rect x="612" y="288" rx="4" ry="4" width="588" height="120" />

      <rect x="0" y="432" rx="4" ry="4" width="588" height="120" />
      <rect x="612" y="432" rx="4" ry="4" width="588" height="120" />

      <rect x="0" y="576" rx="4" ry="4" width="588" height="120" />
      <rect x="612" y="576" rx="4" ry="4" width="588" height="120" />

      <rect x="0" y="720" rx="4" ry="4" width="588" height="120" />
      <rect x="612" y="720" rx="4" ry="4" width="588" height="120" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  components: { ContentLoader },
  props: {
    width: {
      type: Number,
      default: 1200
    },
    height: {
      type: Number,
      default: 376
    },
    speed: {
      type: Number,
      default: 2
    },
    backgroundColor: {
      type: String,
      default: '#f3f3f3'
    },
    foregroundColor: {
      type: String,
      default: '#ecebeb'
    },
    loaderType: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.loading {
  width: 100%;
  height: 376px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentLoader/AppLoader.vue